module.exports = __webpack_public_path__ + "static/media/Ansar.dcc5d114.svg";